// Wedding Website Atomic Colors
// These are the atomic color values from Figma referenced by theme variables

export const WEDDING_WEBSITE_ATOMIC_COLORS = {
  // Roses theme colors
  '--color-cream': '#f8f6ec',
  '--color-baby-pink-120': '#edc9d1',
  '--color-baby-pink': '#efd4da',
  '--color-baby-pink-80': '#fbe7eb',

  // Foliage theme colors
  '--color-foliage-eucalyptus-light': '#eff8f2',
  '--color-foliage-eucalyptus-80': '#a9d2b8',
  '--color-foliage-eucalyptus': '#97b7a3',
  '--color-foliage-eucalyptus-120': '#7eaa8e',

  // Whimsical theme colors
  '--color-whimsical-mauve': '#dc92a9',
  '--color-whimsical-pink-joy-80': '#fff5f1',
  '--color-whimsical-pink-joy': '#ffeee8',
  '--color-whimsical-pink-joy-120': '#ffdacb',
  '--color-whimsical-oxblood': '#280d15',
  '--color-whimsical-mulberry': '#8b2d4b',

  // Neutral colors
  '--color-neutrals-black-a20': 'rgba(0, 0, 0, 0.2)',
  '--color-neutrals-brown': '#635e58',
  '--color-neutrals-dark-brown': '#4A4444',
  '--color-white-a10': 'rgba(255, 255, 255, 0.1)',
  '--color-white-a30': 'rgba(255, 255, 255, 0.3)',
  '--color-white-a40': 'rgba(255, 255, 255, 0.4)',
  '--color-white-a60': 'rgba(255, 255, 255, 0.6)',
  '--color-white-a80': 'rgba(255, 255, 255, 0.8)',
  '--color-invisible': 'transparent',
  '--color-cloudy': '#F6F6F6',
  '--color-neutrals-slate': '#55504F',

  // Dusty rose colors
  '--color-dusty-rose-80': '#b47276',
  '--color-dusty-rose': '#9f585d',
  '--color-dusty-rose-120': '#924248',

  // Bordeaux colors
  '--color-bordeaux': '#57090e',

  // Crimson colors
  '--color-crimson': '#6c030a',

  // Navy colors (Glamour Navy)
  '--color-navy': '#132a46',
  '--color-navy-light': '#c1d7f2',

  // Champagne colors (Glamour Champagne)
  '--color-champagne': '#ffe6c0',

  // Glamour darkblue overlay colors (shared between Navy and Champagne themes)
  '--color-umber-a20': 'rgba(21, 10, 9, 0.2)',
  '--color-umber-a10': 'rgba(21, 10, 9, 0.1)',

  // Gold colors
  '--color-gold-cta': '#b1874c',
  '--color-gold-80': '#e2ac62',
  '--color-gold': '#d39847',
  '--color-gold-120': '#c78a36',

  // Sage
  '--color-sage-120': '#3D864E',
  '--color-sage': '#519360',
  '--color-sage-80': '#99CBA1',
  '--color-sage-40': '#B0D7B6',
  '--color-sage-20': '#C7E2CA',

  // Blush
  '--color-blush-120': '#E2756B',
  '--color-blush': '#F4867D',
  '--color-blush-80': '#FFBEB8',
  '--color-blush-40': '#FFDBD8',
  '--color-blush-20': '#FFEAE9',

  // Blue
  '--color-blue-light': '#ECF5FA',
  '--color-blue-80': '#8EC7E8',
  '--color-blue': '#4E9ECC',
  '--color-blue-120': '#2E8BC0',

  // Orange
  '--color-orange-light': '#FFEFE1',
  '--color-orange-80': '#F2B086',
  '--color-orange': '#E68D55',
  '--color-orange-120': '#DF7735',

  // Roses Plum
  '--color-dark-plum-80': '#E1A9BD',
  '--color-dark-plum': '#C78DA1',
  '--color-dark-plum-120': '#C87B96',
  '--color-plum': '#CEB5C1',

  // Roses brown
  '--color-dusty-brown': '#5B4D4D',
  '--color-mauve-80': '#E5B5C2',
  '--color-mauve-60': '#F3CBD6',

  // Whimsical green
  '--color-emerald': '#0A4E36',
  '--color-dark-emerald-80': '#104D37',
  '--color-dark-emerald': '#093928',
  '--color-dark-emerald-120': '#062C1F',

  // Whimsical beige
  '--color-porcelain': '#FFFBF7',
  '--color-sand-80': '#F4EDE8',
  '--color-sand': '#EBE0D8',
  '--color-sand-120': '#E2D4C9',

  // Sketches Green
  '--color-sketches-green': '#61947b',
  '--color-sketches-dark-green': '#03431e',

  // Sketches Lilac
  '--color-lilac': '#d2cee9',

  // Timeless colors
  '--color-dust': '#FBFDFF',
  '--color-dove-80': '#E4EDF5',
  '--color-dove': '#DAE3EB',
  '--color-dove-120': '#8DA0B0',

  // Blossom colors
  '--color-beige-80': '#FAF4E6',
  '--color-beige': '#E8E4D9',
  '--color-beige-120': '#CAC4B6',
} as const;
